// extracted by mini-css-extract-plugin
export default {"cls1":"SearchUpsell-cls1___218a18ddc5ffea14cc9","cls2":"SearchUpsell-cls2___3bb8883a9a5f6ca0434 SearchUpsell-cls1___218a18ddc5ffea14cc9"};